import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { TableMemoryPagination } from '@/services/table-memory-pagination'

export interface TerminalQueryParams {
  key_word: string // 关键词搜索
  page: number // 页码
  limit: number // 每页数量
  sort: string // 排序字段名
  asc: boolean // true-正序，false-逆序
  useMemory: boolean // 是否使用内存数据
}

export interface TerminalItem {
  /** 终端id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 登记用户信息 */
  user_mark: string
  /** 内网IP */
  client_ip: string
  /** 内网IP */
  system_ip: string
  /** 活跃数 */
  active_count: number
  /** 未优化数 */
  not_optimized_count: number
  /** 已优化数 */
  optimized_count: number
  /** 登录状态,1-在线，2-离线 */
  login_status: number
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
}

export interface DetailQueryParams {
  device_id: string // 关键词搜索
  optimize_type: number // 启动项类型,0-活跃，1-可优化，2-已优化
  page: number // 页码
  limit: number // 每页数量
}

export interface DetailItem {
  soft_name: string // 启动项名
  description: string // 描述row
  app_name: string // 应用名称
  autorun_type: number // 启动类型
  suggest_action: number // 建议操作
  autorun_hash: string // 启动项hash
}

export interface OrderOptions {
  execute_type: number,
  device_list: string[],
  group_id: number
}

@Injectable()
export class TerminalViewService extends TableMemoryPagination<TerminalQueryParams, TerminalItem> {
  constructor (private http: Http) {
    super()
  }

  isEqual (left: TerminalItem, right: TerminalItem): boolean {
    return left.device_id === right.device_id
  }

  @ParamsClean()
  @InvokeThrottle()
  getListByServer (options: TerminalQueryParams) {
    return this.http
      .post<{
        total: number,
        list: TerminalItem[]
      }>('terminal/terminal-start-item/stat', options)
  }

  @ParamsClean()
  @InvokeThrottle()
  fetchDetailList (options: DetailQueryParams) {
    return this.http
      .post<{
        total: number,
        list: DetailItem[]
      }>('terminal/terminal-start-item/list', options)
  }

  @InvokeThrottle()
  scanReport (options: OrderOptions) {
    return this.http
      .post('/terminal-order/autorun-scan', options)
  }
}
